import React from 'react';
import { Flex } from 'rebass';
import { FormComboGroup, Select } from '../../components/Form';
import { FilterBarProps } from '../../components/FilterBar/FilterBar';
import Button from '../../components/Button/Button';

export type NoticeFilters = {
  archived?: string;
};

export type FilterBarNoticeProps = FilterBarProps<NoticeFilters>;

export const defaultFilters: NoticeFilters = {
  archived: 'active',
};

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
];

const FilterBarNotice: React.FC<FilterBarNoticeProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (e: any) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <FormComboGroup>
          <Select
            name="archived"
            value={filters.archived}
            onChange={onChange}
            width={130}
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </FormComboGroup>
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => setFilters(defaultFilters)}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

export default FilterBarNotice;
